export default {
  install(Vue) {
    /*
    * 全局变量设置
    * */
    Vue.prototype.setSingleGlobalVariable = function (key, val) {
      sessionStorage.setItem(key, val)
    }
    Vue.prototype.getSingleGlobalVariable = function (key) {
      return sessionStorage.getItem(key);
    }


    Vue.prototype.setGlobalVariable = function (key, val) {
      sessionStorage.setItem(key, JSON.stringify(val))
    }
    Vue.prototype.getGlobalVariable = function (key) {
      return JSON.parse(sessionStorage.getItem(key));
    }
    Vue.prototype.clearGlobalVariable = function () {
      sessionStorage.clear();
    }
    Vue.prototype.removeGlobalVariable = function (key) {
      sessionStorage.removeItem(key);
    }
  }

}

